import { render, staticRenderFns } from "./HomeBottomContent.vue?vue&type=template&id=1512988c&scoped=true"
import script from "./HomeBottomContent.vue?vue&type=script&lang=js"
export * from "./HomeBottomContent.vue?vue&type=script&lang=js"
import style0 from "./HomeBottomContent.vue?vue&type=style&index=0&id=1512988c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1512988c",
  null
  
)

export default component.exports